import { render, staticRenderFns } from "./Layout_UserInfo.vue?vue&type=template&id=603e9c04"
import script from "./Layout_UserInfo.vue?vue&type=script&lang=js"
export * from "./Layout_UserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports